import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { LoginService } from '@app/core/auth';

@Component({
  //selector: 'lud-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HomeComponent implements OnInit, OnDestroy {
  static route = '';

  private subscriptions: Subscription[] = [];

  constructor(
    private readonly loginService: LoginService,
    private readonly router: Router,
  ) {
  }

  ngOnInit() {

    this.subscriptions.push(
      this.loginService.userProfile$
        .subscribe(userProfile => {
          if (userProfile && this.router.url === '/') {
            this.router.navigate(['/dashboard']);
          }
        })
    );
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
